module.exports = __webpack_public_path__ + "static/img/Tim.Watson.40930aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tim.Watson.jpg
// module id = /4zV
// module chunks = 0